import * as API from '@common/api/star-map'
import * as T from './types'

export default {
    [T.OPEN_STAR_MAP]({ dispatch }, payload) {
        return API.openStarMap(payload).then(() => {
            dispatch(T.GET_STAR_MAP_DETAIL, payload)
        })
    },
    [T.GET_STAR_MAP_DETAIL]({ commit }, payload) {
        return API.getStarMapDetail(payload).then(data => {
            commit(T.SET_STAR_DATA, data)
        })
    },
    [T.SAVE_STAR_MAP_ENV_DEPLOY]({ dispatch }, payload) {
        return API.saveStarMapEnvDeploy(payload).then(() => {
            dispatch(T.GET_STAR_MAP_DETAIL, payload.appId)
        })
    },
    [T.GET_MIP_ENV_LIST](store, payload) {
        return API.getMipEnvList(payload)
    },
    [T.GET_MIP_API_LIST]({ commit }, payload) {
        return API.getMipApiList(payload).then(data => {
            commit(T.SET_MIP_API_LIST, data)
        }).catch(() => {
            commit(T.SET_MIP_API_LIST, [])
        })
    },
    [T.GET_MIP_API_DETAIL](store, payload) {
        return API.getMipApiDetail(payload)
    },
    [T.GET_MIP_API_HISTORY_DETAIL](store, payload) {
        return API.getMipApiHistoryDetail(payload)
    },
    [T.ADD_ENV_MAP](store, payload) {
        return API.addEnvMap(payload)
    },
    [T.DELETE_ENV_MAP](store, payload) {
        return API.deleteEnvMap(payload)
    },
    [T.GET_BUSINESS_ENV_LIST_BY_CATEGORY](store, payload) {
        return API.getBusinessEnvListByCategory(payload)
    },
    [T.GET_ENV_BINDING_LIST](store, payload) {
        return API.getEnvBindingList(payload)
    },
    [T.GET_STAR_MAP_BINDING_DETAIL](store, payload) {
        return API.getStarMapBindingDetail(payload)
    },
    [T.UPDATE_STAR_MAP_INFO](store,  params) {
        return API.updateStarMapInfo(params)
    },
    [T.UPDATE_STAR_MIP_API](store, params) {
        return API.updateStarMipApi(params)
    },
    [T.UPDATE_STAR_MIP_API_LIST](store, params) {
        return API.updateStarMipApiList(params)
    },
}
